<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin, BFormInput,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import PicItem from '../../picitem/list/Index.vue';

export default {
  components: {
    BFormInput,
    BModal,
    PicItem,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        picid: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {
      dataFromApiTipoPicId: null,
      dataFromApiTipoPedidoId: null,
      optionsEstabelecimento: [],
      dataFromApiCondicaoPagamento: [],
      dataFromApiCanalVenda: [],
      dataFromApiCliente: [],
      options: [
        {
          label: 'Valor Bruto',
          value: 'B',
        },
        {
          label: 'Valor Liquido',
          value: 'L',
        },
      ],
      optionsTipoFrete: [
        {
          label: 'Selecione um frete',
          value: 'Selecione um frete',
        },
        {
          label: 'CIF',
          value: 'CIF',
        },
        {
          label: 'FOB',
          value: 'FOB',
        },
      ],
    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
  methods: {
    onModalShow() {
      this.fetchDataFromTipoPic();
      // this.fetchDataFromEstabelecimento()
      // this.fetchDataFromTipoPedido()
      this.fetchDataFromCanalVenda();
      this.fetchDataFromCondicaoPagamento();
      this.fetchDataFromCliente();
    },
    async validateForm() {
      try {
        this.$emit('ok', this.dataForm);
        this.$bvModal.hide(this.idModal);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sucesso',
            text: 'Pic atualizado com sucesso',
            icon: 'CheckIcon',
            variant: 'success',
          },
        });
      } catch (error) {
        console.error('Erro ao validar o formulário:', error);
      }
    },
    toUpperCase() {
      this.dataForm.tipopicid = this.dataForm.tipopicid.toUpperCase();
    },
    async fetchDataFromTipoPedido() {
      try {
        const response = await axios.get('/tipo-pedido');
        this.dataFromApiTipoPedidoId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromTabelaPreco() {
      try {
        const response = await axios.get('/tabela-preco');
        this.dataFromApiTabelaPreco = [
          { tabelapreco_id: 0, tabelapreco_descricao: 'Nenhuma' },
          ...response.data.data,
        ];
        this.dataFromApiTabelaPreco = response.data.data.map((option) => ({
          value: option.tabelapreco_id,
          text: `${option.tabelapreco_id}   -  ${option.tabelapreco_descricao} `,
        }));
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromTipoPic() {
      try {
        const response = await axios.get('/tipo-pic');
        this.dataFromApiTipoPicId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromCanalVenda() {
      try {
        const response = await axios.get('/canal-venda');
        this.dataFromApiCanalVenda = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromCliente() {
      try {
        const response = await axios.get('/cliente?page=1&perPage=4000&sortBy=clientenomefantasia&sortDesc=false');
        this.dataFromApiCliente = response.data.data.map((option) => ({
          value: option.clienteid,
          text: `${option.clienteid}   -  ${option.clientenomefantasia} `,
        }));
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromCondicaoPagamento() {
      try {
        const response = await axios.get('/condicao-pagamento');
        this.dataFromApiCondicaoPagamento = response.data.data.map((option) => ({
          value: option.condicaopagamentoid,
          text: `${option.condicaopagamentoid}  -  ${option.condicaopagamentodescricao}`,
        }));
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromEstabelecimento() {
      try {
        const response = await axios.get('/estabelecimento');
        this.optionsEstabelecimento = response.data.data.map((option) => ({
          value: option.estabelecimentoid,
          text: `${option.estabelecimentorazaosocial} - ${option.estabelecimentoid}`,
        }));
      } catch (error) {
        console.error('Erro ao buscar estabelecimentos:', error);
      }
    },
  },
};
</script>

<template>

  <b-modal no-close-on-backdrop no-close-on-esc size="xl" :id="idModal" :title="titleModal"
    :ok-disabled="dataForm.isDefault || dataForm.tipopicdescricao === ''" :ok-title="labelBtnOk" ok-variant="success"
    cancel-variant="secondary" body-bg-variant="light" cancel-title="Cancelar" @ok="validateForm"
    @cancel="$emit('cancel')" @close="$emit('cancel')">
    <b-card>
      <validation-observer ref="refFormData">
        <b-tabs>
          <b-tab title="Formulário">
            <b-form @submit.prevent>
              <b-row>
                <b-col cols="4" class="mb-1">
                  <b-form-group label="Descrição" label-for="picdescricao">
                    <validation-provider #default="{ errors }" name="Descrição" rules="required">
                      <b-form-input v-model="dataForm.picdescricao" id="picdescricao"
                        :state="errors.length > 0 ? false : null" placeholder="Digite a descrição"
                        :disabled="dataForm.picsituacao !== 'Digitação'" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="4" class="mb-1">
                  <b-form-group label="Tipo Pic" label-for="tipopicid">
                    <validation-provider #default="{ errors }" name="Descrição" rules="required">
                      <b-form-input v-model="dataForm.DadosTipopic.tipopicdescricao" id="tipopicid"
                        :state="errors.length > 0 ? false : null" placeholder="Digite o código" disabled />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="4" class="mb-1">
                  <b-form-group label="Data Faturamento" label-for="picdatafaturamento">
                    <validation-provider #default="{ errors }" name="picdatafaturamento" rules="required">
                      <b-form-input v-model="dataForm.picdatafaturamento" id="picdatafaturamento"
                        :state="errors.length > 0 ? false : null" type="date" disabled />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="4" class="mb-1">
                  <b-form-group label="Validade Inicio" label-for="piciniciovalidade">
                    <validation-provider #default="{ errors }" name="piciniciovalidade" rules="required">
                      <b-form-input v-model="dataForm.piciniciovalidade" id="piciniciovalidade"
                        :state="errors.length > 0 ? false : null" type="date" disabled />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="4" class="mb-1">
                  <b-form-group label="Validade Termino" label-for="picterminovalidade">
                    <validation-provider #default="{ errors }" name="picterminovalidade" rules="required">
                      <b-form-input v-model="dataForm.picterminovalidade" id="picterminovalidade"
                        :state="errors.length > 0 ? false : null" type="date" disabled />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="4" class="mb-1">
                  <b-form-group label="Hora: " label-for="picterminovalidadehora">
                    <validation-provider #default="{ errors }" name="picterminovalidadehora" rules="required">
                      <b-form-input v-model="dataForm.picterminovalidadehora" id="picterminovalidadehora"
                        :state="errors.length > 0 ? false : null" type="time" disabled />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="4" class="mb-1" v-if="dataForm.Cliente">
                  <b-form-group label="Cliente" label-for="clienteid">
                    <validation-provider #default="{ errors }" name="clienteid" rules="required">
                      <b-form-input v-model="dataForm.Cliente.clientenomefantasia" id="clienteid"
                        :state="errors.length > 0 ? false : null" disabled />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="4" class="mb-1">
                  <b-form-group label="Condicao Pagamento" label-for="condicaopagamentoid">
                    <validation-provider #default="{ errors }" name="condicaopagamentoid" rules="required">
                      <b-form-select v-model="dataForm.condicaopagamentoid" id="picaprovacao"
                        :state="errors.length > 0 ? false : null" text-field="text" value-field="value"
                        :options="dataFromApiCondicaoPagamento" disabled />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="4" class="mb-1">
                  <b-form-group label="Estabelecimento" label-for="estabelecimentoid">
                    <validation-provider #default="{ errors }" name="estabelecimentoid" rules="required">
                      <b-form-input value="HANESBRANDS BRASIL TEXTIL LTDA." id="estabelecimentoid"
                        :state="errors.length > 0 ? false : null" disabled />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="4" class="mb-1">
                  <b-form-group label="Tipo Pedido" label-for="tipopedidoid">
                    <validation-provider #default="{ errors }" name="tipopedidoid" rules="required">
                      <b-form-input value="VENDA PRODUÇÃO PRÓPRIA" id="tipopedidoid"
                        :state="errors.length > 0 ? false : null" disabled />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="4" class="mb-1">
                  <b-form-group label="Tipo Frete" label-for="pictipofrete">
                    <validation-provider #default="{ errors }" name="pictipofrete" rules="required">
                      <b-form-input value="CIF" id="pictipofrete" :state="errors.length > 0 ? false : null" disabled />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="mb-1">
                  <b-form-group label="Observação" label-for="picobservacao">
                    <validation-provider #default="{ errors }" name="picobservacao" rules="required">
                      <b-form-textarea v-model="dataForm.picobservacao" id="picobservacao"
                        :state="errors.length > 0 ? false : null" :disabled="dataForm.picsituacao !== 'Digitação'" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col v-if="dataForm.picsituacao === 'Reprovada'" cols="12" class="mb-1">
                  <b-alert variant="danger" show>
                    <h4 class="alert-heading">
                      Motivo Reprovação
                    </h4>
                    <div class="alert-body">
                      <span>{{ dataForm.picobservacaoaprovador }}</span>
                    </div>
                  </b-alert>
                </b-col>
              </b-row>
            </b-form>
          </b-tab>
          <b-tab title="Itens">
            <div class="mt-2">
              <h3>Itens</h3>
              <PicItem :picidbusca="dataForm.picid" :picsituacao="dataForm.picsituacao" />
            </div>
          </b-tab>
        </b-tabs>

      </validation-observer>
    </b-card>

  </b-modal>
</template>
